import baseFetch, { createParamString } from '../baseFetch';
import { findMeterFromArguments, getMeterParamsForRequest } from '../../utils/meteringHelper';

export const fetchWaveForecast = (
  spotId,
  days,
  intervalHours,
  maxHeights = false,
  sds,
  corrected,
  ...rest
) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/spots/forecasts/wave?${createParamString({
      spotId,
      days,
      intervalHours,
      maxHeights,
      meterRemaining,
      sds,
      corrected,
    })}`,
    { ...meterHeaders },
  );
};

export const fetchTideForecast = (spotId, days, ...rest) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/spots/forecasts/tides?${createParamString({ spotId, days, meterRemaining })}`,
    {
      ...meterHeaders,
    },
  );
};

export const fetchWeatherForecast = (spotId, days, intervalHours, sds, corrected, ...rest) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/spots/forecasts/weather?${createParamString({
      spotId,
      days,
      intervalHours,
      meterRemaining,
      sds,
      corrected,
    })}`,
    { ...meterHeaders },
  );
};

export const fetchWindForecast = (spotId, days, intervalHours, sds, corrected, ...rest) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/spots/forecasts/wind?${createParamString({
      spotId,
      days,
      intervalHours,
      meterRemaining,
      sds,
      corrected,
    })}`,
    { ...meterHeaders },
  );
};

export const fetchRegionalConditionForecast = (subregionId, days, ...rest) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/regions/forecasts/conditions?${createParamString({
      subregionId,
      days,
      meterRemaining,
    })}`,
    { ...meterHeaders },
  );
};

export const fetchRegionalWaveForecast = (
  subregionId,
  days,
  intervalHours,
  maxHeights = false,
  ...rest
) => {
  const meterObject = findMeterFromArguments(rest);
  const meter = meterObject?.meter;
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(
    `/kbyg/regions/forecasts/wave?${createParamString({
      subregionId,
      days,
      intervalHours,
      maxHeights,
      meterRemaining,
    })}`,
    { ...meterHeaders },
  );
};

export const fetchTaxononmySwellEvents = (id, type, meter) => {
  const { meterHeaders, meterRemaining } = getMeterParamsForRequest(meter);
  return baseFetch(`/kbyg/events/taxonomy?${createParamString({ id, type, meterRemaining })}`, {
    ...meterHeaders,
  });
};
